/*
 * NATIVE PUSH — Capacitor Push Notifications (addendum §14.10: APNs on iOS, FCM on Android).
 * ----------------------------------------------------------------------------
 * STUB WIRING: on a real device this registers for push and hands the device
 * token to the engine (bound to the signed identity, never a client `who`).
 * In the browser/dev build there is no native bridge, so this no-ops cleanly.
 * The engine sends severity-routed per NICKS-UPDATES-SPEC §6 (urgent=push,
 * needs-nick=badge, fyi=silent); quiet hours + no-private-content are enforced
 * engine-side, not here.
 */
import { Capacitor } from '@capacitor/core';

export async function initPush(
  registerToken: (token: string, platform: string) => Promise<void>,
): Promise<void> {
  if (!Capacitor.isNativePlatform()) {
    // Web/dev: no native push bridge. Real native push activates in the built app.
    return;
  }
  // Dynamic import so the web bundle never pulls the native-only plugin.
  const { PushNotifications } = await import('@capacitor/push-notifications');
  const perm = await PushNotifications.requestPermissions();
  if (perm.receive !== 'granted') return;
  await PushNotifications.register();
  const platform = Capacitor.getPlatform(); // 'ios' | 'android'
  PushNotifications.addListener('registration', (t) => {
    // Hand the device token to the engine/store bridge (POST /api/push/register).
    void registerToken(t.value, platform);
  });
}
